/**
 * ISO 3166-1 Numeric Country Codes used in SmartEco device serial numbers.
 * Position 8-10 of the serial number (after SEI + version + model letter) is the 3-digit
 * country code of the client the device was manufactured for.
 *
 * Source: SerialNumber.txt reference doc maintained by hardware team.
 */
export interface CountryCode {
  code: string;
  name: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: '004', name: 'Afghanistan' },
  { code: '008', name: 'Albania' },
  { code: '012', name: 'Algeria' },
  { code: '016', name: 'American Samoa' },
  { code: '020', name: 'Andorra' },
  { code: '024', name: 'Angola' },
  { code: '028', name: 'Antigua and Barbuda' },
  { code: '031', name: 'Azerbaijan' },
  { code: '032', name: 'Argentina' },
  { code: '036', name: 'Australia' },
  { code: '040', name: 'Austria' },
  { code: '044', name: 'Bahamas' },
  { code: '048', name: 'Bahrain' },
  { code: '050', name: 'Bangladesh' },
  { code: '051', name: 'Armenia' },
  { code: '052', name: 'Barbados' },
  { code: '056', name: 'Belgium' },
  { code: '060', name: 'Bermuda' },
  { code: '064', name: 'Bhutan' },
  { code: '068', name: 'Bolivia' },
  { code: '070', name: 'Bosnia and Herzegovina' },
  { code: '072', name: 'Botswana' },
  { code: '076', name: 'Brazil' },
  { code: '084', name: 'Belize' },
  { code: '090', name: 'Solomon Islands' },
  { code: '092', name: 'British Virgin Islands' },
  { code: '096', name: 'Brunei Darussalam' },
  { code: '100', name: 'Bulgaria' },
  { code: '104', name: 'Myanmar' },
  { code: '108', name: 'Burundi' },
  { code: '112', name: 'Belarus' },
  { code: '116', name: 'Cambodia' },
  { code: '120', name: 'Cameroon' },
  { code: '124', name: 'Canada' },
  { code: '132', name: 'Cabo Verde' },
  { code: '136', name: 'Cayman Islands' },
  { code: '140', name: 'Central African Republic' },
  { code: '144', name: 'Sri Lanka' },
  { code: '148', name: 'Chad' },
  { code: '152', name: 'Chile' },
  { code: '156', name: 'China' },
  { code: '158', name: 'Taiwan' },
  { code: '162', name: 'Christmas Island' },
  { code: '166', name: 'Cocos (Keeling) Islands' },
  { code: '170', name: 'Colombia' },
  { code: '174', name: 'Comoros' },
  { code: '175', name: 'Mayotte' },
  { code: '178', name: 'Congo' },
  { code: '184', name: 'Cook Islands' },
  { code: '188', name: 'Costa Rica' },
  { code: '191', name: 'Croatia' },
  { code: '192', name: 'Cuba' },
  { code: '196', name: 'Cyprus' },
  { code: '203', name: 'Czech Republic' },
  { code: '204', name: 'Benin' },
  { code: '208', name: 'Denmark' },
  { code: '212', name: 'Dominica' },
  { code: '214', name: 'Dominican Republic' },
  { code: '218', name: 'Ecuador' },
  { code: '222', name: 'El Salvador' },
  { code: '226', name: 'Equatorial Guinea' },
  { code: '231', name: 'Ethiopia' },
  { code: '232', name: 'Eritrea' },
  { code: '233', name: 'Estonia' },
  { code: '234', name: 'Faroe Islands' },
  { code: '238', name: 'Falkland Islands' },
  { code: '242', name: 'Fiji' },
  { code: '246', name: 'Finland' },
  { code: '250', name: 'France' },
  { code: '262', name: 'Djibouti' },
  { code: '266', name: 'Gabon' },
  { code: '268', name: 'Georgia' },
  { code: '270', name: 'Gambia' },
  { code: '276', name: 'Germany' },
  { code: '288', name: 'Ghana' },
  { code: '292', name: 'Gibraltar' },
  { code: '296', name: 'Kiribati' },
  { code: '300', name: 'Greece' },
  { code: '304', name: 'Greenland' },
  { code: '308', name: 'Grenada' },
  { code: '312', name: 'Guadeloupe' },
  { code: '316', name: 'Guam' },
  { code: '320', name: 'Guatemala' },
  { code: '324', name: 'Guinea' },
  { code: '328', name: 'Guyana' },
  { code: '332', name: 'Haiti' },
  { code: '336', name: 'Vatican City' },
  { code: '340', name: 'Honduras' },
  { code: '344', name: 'Hong Kong' },
  { code: '348', name: 'Hungary' },
  { code: '352', name: 'Iceland' },
  { code: '356', name: 'India' },
  { code: '360', name: 'Indonesia' },
  { code: '364', name: 'Iran' },
  { code: '368', name: 'Iraq' },
  { code: '372', name: 'Ireland' },
  { code: '376', name: 'Israel' },
  { code: '380', name: 'Italy' },
  { code: '384', name: "Ivory Coast (Côte d'Ivoire)" },
  { code: '388', name: 'Jamaica' },
  { code: '392', name: 'Japan' },
  { code: '400', name: 'Jordan' },
  { code: '404', name: 'Kenya' },
  { code: '408', name: 'Korea, North' },
  { code: '410', name: 'Korea, South' },
  { code: '414', name: 'Kuwait' },
  { code: '417', name: 'Kyrgyzstan' },
  { code: '418', name: 'Laos' },
  { code: '422', name: 'Lebanon' },
  { code: '426', name: 'Lesotho' },
  { code: '428', name: 'Latvia' },
  { code: '430', name: 'Liberia' },
  { code: '434', name: 'Libya' },
  { code: '438', name: 'Liechtenstein' },
  { code: '440', name: 'Lithuania' },
  { code: '442', name: 'Luxembourg' },
  { code: '446', name: 'Macau' },
  { code: '450', name: 'Madagascar' },
  { code: '454', name: 'Malawi' },
  { code: '458', name: 'Malaysia' },
  { code: '462', name: 'Maldives' },
  { code: '466', name: 'Mali' },
  { code: '470', name: 'Malta' },
  { code: '474', name: 'Martinique' },
  { code: '478', name: 'Mauritania' },
  { code: '480', name: 'Mauritius' },
  { code: '484', name: 'Mexico' },
  { code: '492', name: 'Monaco' },
  { code: '496', name: 'Mongolia' },
  { code: '498', name: 'Moldova' },
  { code: '499', name: 'Montenegro' },
  { code: '504', name: 'Morocco' },
  { code: '508', name: 'Mozambique' },
  { code: '512', name: 'Oman' },
  { code: '516', name: 'Namibia' },
  { code: '520', name: 'Nauru' },
  { code: '524', name: 'Nepal' },
  { code: '528', name: 'Netherlands' },
  { code: '533', name: 'Aruba' },
  { code: '534', name: 'Sint Maarten (Dutch part)' },
  { code: '548', name: 'Vanuatu' },
  { code: '554', name: 'New Zealand' },
  { code: '558', name: 'Nicaragua' },
  { code: '562', name: 'Niger' },
  { code: '566', name: 'Nigeria' },
  { code: '570', name: 'Niue' },
  { code: '574', name: 'Norfolk Island' },
  { code: '578', name: 'Norway' },
  { code: '580', name: 'Northern Mariana Islands' },
  { code: '583', name: 'Micronesia' },
  { code: '584', name: 'Marshall Islands' },
  { code: '585', name: 'Palau' },
  { code: '586', name: 'Pakistan' },
  { code: '591', name: 'Panama' },
  { code: '598', name: 'Papua New Guinea' },
  { code: '600', name: 'Paraguay' },
  { code: '604', name: 'Peru' },
  { code: '608', name: 'Philippines' },
  { code: '612', name: 'Pitcairn Islands' },
  { code: '616', name: 'Poland' },
  { code: '620', name: 'Portugal' },
  { code: '624', name: 'Guinea-Bissau' },
  { code: '626', name: 'East Timor (Timor-Leste)' },
  { code: '630', name: 'Puerto Rico' },
  { code: '634', name: 'Qatar' },
  { code: '638', name: 'Réunion Islands' },
  { code: '642', name: 'Romania' },
  { code: '643', name: 'Russia' },
  { code: '646', name: 'Rwanda' },
  { code: '652', name: 'Saint Barthélemy' },
  { code: '654', name: 'Saint Helena' },
  { code: '659', name: 'Saint Kitts and Nevis' },
  { code: '660', name: 'Anguilla' },
  { code: '662', name: 'Saint Lucia' },
  { code: '663', name: 'Saint Martin (French part)' },
  { code: '666', name: 'Saint Pierre and Miquelon' },
  { code: '670', name: 'Saint Vincent and the Grenadines' },
  { code: '674', name: 'San Marino' },
  { code: '678', name: 'São Tomé and Príncipe' },
  { code: '682', name: 'Saudi Arabia' },
  { code: '686', name: 'Senegal' },
  { code: '688', name: 'Serbia' },
  { code: '690', name: 'Seychelles' },
  { code: '694', name: 'Sierra Leone' },
  { code: '702', name: 'Singapore' },
  { code: '703', name: 'Slovakia' },
  { code: '704', name: 'Vietnam' },
  { code: '705', name: 'Slovenia' },
  { code: '706', name: 'Somalia' },
  { code: '710', name: 'South Africa' },
  { code: '716', name: 'Zimbabwe' },
  { code: '724', name: 'Spain' },
  { code: '728', name: 'South Sudan' },
  { code: '729', name: 'Sudan' },
  { code: '732', name: 'Western Sahara' },
  { code: '740', name: 'Suriname' },
  { code: '744', name: 'Svalbard and Jan Mayen' },
  { code: '748', name: 'Eswatini' },
  { code: '752', name: 'Sweden' },
  { code: '756', name: 'Switzerland' },
  { code: '760', name: 'Syria' },
  { code: '762', name: 'Tajikistan' },
  { code: '764', name: 'Thailand' },
  { code: '768', name: 'Togo' },
  { code: '772', name: 'Tokelau' },
  { code: '776', name: 'Tonga' },
  { code: '780', name: 'Trinidad and Tobago' },
  { code: '784', name: 'United Arab Emirates' },
  { code: '788', name: 'Tunisia' },
  { code: '792', name: 'Turkey' },
  { code: '795', name: 'Turkmenistan' },
  { code: '798', name: 'Tuvalu' },
  { code: '800', name: 'Uganda' },
  { code: '804', name: 'Ukraine' },
  { code: '807', name: 'North Macedonia' },
  { code: '818', name: 'Egypt' },
  { code: '826', name: 'United Kingdom' },
  { code: '834', name: 'Tanzania' },
  { code: '840', name: 'United States' },
  { code: '854', name: 'Burkina Faso' },
  { code: '858', name: 'Uruguay' },
  { code: '860', name: 'Uzbekistan' },
  { code: '862', name: 'Venezuela' },
  { code: '876', name: 'Wallis and Futuna' },
  { code: '882', name: 'Samoa' },
  { code: '887', name: 'Yemen' },
  { code: '894', name: 'Zambia' },
];

const COUNTRY_CODE_SET = new Set(COUNTRY_CODES.map(c => c.code));

export function isValidCountryCode(code: string): boolean {
  return COUNTRY_CODE_SET.has(code);
}

export function getCountryName(code: string): string | null {
  return COUNTRY_CODES.find(c => c.code === code)?.name ?? null;
}
